var _path, _path2, _path3, _circle, _circle2, _circle3, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChaser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#E1E9F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3912 14.7566L34.2457 19.1301C34.5475 19.8414 34.7027 20.6066 34.7027 21.3789V33.6496C34.7027 35.5059 33.198 37.0094 31.3424 37.0094C29.6361 37.0094 28.227 35.7379 28.0113 34.0902H11.2734C11.0572 35.7379 9.64805 37.0094 7.9418 37.0094C6.08613 37.0094 4.58203 35.5059 4.58203 33.6496V22.3492C4.58203 21.6098 4.72441 20.8773 5.00098 20.193L7.69277 13.5273C8.57227 11.35 10.6857 9.92383 13.0342 9.92383H21.1436L21.3275 11.882C21.385 12.4973 21.5391 13.0832 21.774 13.6246L22.6523 15.652H27.3516V17.2539L28.6412 16.8918C29.2102 16.7324 29.7445 16.4863 30.2291 16.1699L32.3912 14.7566Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2573 19.9728L31.4112 17.9769C30.7454 18.4123 30.0101 18.7502 29.2257 18.9706L30.0476 20.9095C30.1104 21.0577 30.1428 21.217 30.1428 21.3779V21.8318C29.7898 21.6276 29.3799 21.5107 28.9428 21.5107H10.3422C9.96404 21.5107 9.60632 21.5982 9.28814 21.754L11.9214 15.2336C12.1046 14.78 12.5449 14.483 13.0341 14.483H19.7923C19.4684 13.7356 19.2563 12.9286 19.1769 12.083H13.0341C11.5664 12.083 10.2457 12.974 9.69606 14.3349L7.00413 21.0005C6.83112 21.4289 6.74219 21.8865 6.74219 22.3486V33.649C6.74219 34.3118 7.27945 34.849 7.94219 34.849C8.60493 34.849 9.14219 34.3118 9.14219 33.649L9.14219 31.7251C9.51752 31.8578 9.92143 31.9299 10.3422 31.9299H28.9428C29.3635 31.9299 29.7674 31.8578 30.1428 31.7251V33.649C30.1428 34.3118 30.68 34.849 31.3428 34.849C32.0055 34.849 32.5428 34.3118 32.5428 33.649V28.3391C32.5428 28.3361 32.5428 28.333 32.5428 28.3299V21.3779C32.5428 20.8951 32.4457 20.4173 32.2573 19.9728Z",
    fill: "#1C53EC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3689,
    cy: 26.7586,
    r: 1.87383,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9168,
    cy: 26.7586,
    r: 1.87383,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.0754,
    cy: 11.3322,
    r: 7.26281,
    fill: "#1C53EC",
    stroke: "white",
    strokeWidth: 2.16,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.9956,
    y: 7.51465,
    width: 2.16,
    height: 4.83867,
    rx: 1.08,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.9956,
    y: 12.9893,
    width: 2.16,
    height: 2.16,
    rx: 1.08,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaser);
export default __webpack_public_path__ + "static/media/chaser.41e99e7c6640dbd1c5db1f416ef41da0.svg";
export { ForwardRef as ReactComponent };